const validatePass = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入密码'))
  } else if (value.length < 6) {
    callback(new Error('密码长度不能小于6位'))
  } else {
    callback()
  }
}

// const validateRegionInfo = (rule, value, callback) => {
//   if (!value || (value && value.length === 0)) {
//     callback(new Error('请选择所在区域'))
//   } else {
//     callback()
//   }
// }
const validateMinMone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入优惠折扣'))
  } else if (isNaN(value)) {
    callback(new Error('请输入正确的数字'))
  } else {
    callback()
  }
}

export function isPhone(rule, value, callback) {
  if (!value) {
    callback(new Error('手机号码为空'))
  } else {
    const reg = /^0?1[3-9][0-9]\d{8}$/
    if (reg.test(value)) {
      callback()
    } else {
      callback(new Error('请输入正确的手机号码'))
    }
  }
}

export const rules = {
  'shopName': [{ required: true, trigger: 'blur', message: '请输入营业执照上的全称' }],
  'shortName': [{ required: true, trigger: 'blur', message: '请输入商户简称' }],
  'regionInfo': [{ required: true, trigger: 'change', message: '请选择所在区域' }],
  'address': [{ required: true, trigger: 'blur', message: '请输入详细地址' }],
  'discount': [{ required: true, trigger: 'blur', validator: validateMinMone }],
  'mobile': [
    { required: true, trigger: 'blur', message: '请输入11位手机号码' },
    { trigger: 'blur', validator: isPhone }
  ],
  'password': [
    { required: true, trigger: 'blur', message: '请输入登录密码' },
    { trigger: 'blur', validator: validatePass }
  ],
  // 'detail.licenceNo': [{ required: true, trigger: 'blur', message: '请输入营业执照编号/统一社会信用代码' }],
  // 'detail.licenseDate': [{ required: true, trigger: 'blur', message: '请输入营业执照有效期' }],
  // 'detail.licenseStart': [{ required: true, trigger: 'blur', message: '请输入营业执照有效期' }],
  // 'detail.legalName': [{ required: true, trigger: 'blur', message: '请输入法人姓名' }],
  // 'detail.legalIdCard': [{ required: true, trigger: 'blur', message: '请输入法人身份证号码' }],
  // 'detail.cardDate': [{ required: true, trigger: 'blur', message: '请输入法人证件有效期' }],
  // 'detail.legalCardStart': [{ required: true, trigger: 'blur', message: '请输入法人证件有效期' }],
  'openHours': [{ required: true, trigger: 'blur', message: '请输入营业时间' }],
  // 'detail.bankIdCard': [{ required: true, trigger: 'blur', message: '请输入结算人身份证号码' }],
  // 'detail.bankAccountName': [{ required: true, trigger: 'blur', message: '请输入结算账户名' }],
  // 'detail.bankNumber': [{ required: true, trigger: 'blur', message: '请输入结算账号' }],
  // 'detail.bankPhone': [
  //   { required: true, trigger: 'blur', message: '请输入银行预留手机号' },
  //   { trigger: 'blur', validator: isPhone }
  // ],
  // 'detail.bankOfDeposit': [{ required: true, trigger: 'blur', message: '请选择开户银行' }],
  'phone': [{ required: true, trigger: 'blur', message: '请输入门店电话' }],
  'feature': [{ required: true, trigger: 'blur', message: '请输入特色介绍' }]
}
